var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.346,
    height: 53.107,
    viewBox: "0 0 52.346 53.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_30",
    "data-name": "Intersection 30",
    d: "M5.741,43.244l-.479,5.681-1.4-.119.708-8.4,8.321,1.315-.218,1.388-5.994-.949A25.019,25.019,0,0,0,51.353,26.681a.7.7,0,0,1,.993-.638v5.288A26.426,26.426,0,0,1,5.741,43.244Zm31.523-7.718H6.646v-4.7a6.271,6.271,0,0,1,6.263-6.265h4.229c.072,0,.143.008.214.01a8.024,8.024,0,0,1,6.3-3.058h5.576a8.022,8.022,0,0,1,6.29,3.048h4.25a6.271,6.271,0,0,1,6.263,6.265v4.7Zm0-5.977v4.575h7.363v-3.3a4.867,4.867,0,0,0-4.86-4.863H36.408A7.978,7.978,0,0,1,37.264,29.549ZM32.836,29.3v4.821H35.86V29.549a6.642,6.642,0,0,0-6.635-6.635H23.649a6.642,6.642,0,0,0-6.635,6.635v4.575h2.7V29.3a.7.7,0,1,1,1.4,0v4.821H31.433V29.3a.7.7,0,1,1,1.4,0ZM8.049,30.824v3.3h7.563V29.549a7.969,7.969,0,0,1,.855-3.587H12.909A4.867,4.867,0,0,0,8.049,30.824ZM0,26.428A26.424,26.424,0,0,1,47.015,9.864l.478-5.681,1.4.119-.708,8.4-8.321-1.316.218-1.388,5.995.949A25.018,25.018,0,0,0,1.4,26.428a.7.7,0,1,1-1.4,0Zm34.145-5.979a3.495,3.495,0,1,1,3.495,3.494A3.5,3.5,0,0,1,34.145,20.448Zm1.4,0a2.092,2.092,0,1,0,2.092-2.093A2.095,2.095,0,0,0,35.548,20.448Zm-23.9,0a3.5,3.5,0,1,1,3.5,3.494A3.5,3.5,0,0,1,11.651,20.448Zm1.4,0a2.092,2.092,0,1,0,2.093-2.093A2.095,2.095,0,0,0,13.054,20.448Zm9.238-4.355a4.146,4.146,0,1,1,4.145,4.145A4.15,4.15,0,0,1,22.292,16.093Zm1.4,0a2.743,2.743,0,1,0,2.743-2.743A2.746,2.746,0,0,0,23.695,16.093Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bec227c7e53c4c9616b4c3647586150c.svg";
export { ForwardRef as ReactComponent };